/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ads_Dialog_Submit_ToolInputs */

const en_directory_ads_dialog_submit_tool = /** @type {(inputs: Directory_Ads_Dialog_Submit_ToolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit a listing first`)
};

const zh_directory_ads_dialog_submit_tool = /** @type {(inputs: Directory_Ads_Dialog_Submit_ToolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先提交一个 listing`)
};

/**
* | output |
* | --- |
* | "Submit a listing first" |
*
* @param {Directory_Ads_Dialog_Submit_ToolInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ads_dialog_submit_tool = /** @type {((inputs?: Directory_Ads_Dialog_Submit_ToolInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ads_Dialog_Submit_ToolInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ads_dialog_submit_tool(inputs)
	return zh_directory_ads_dialog_submit_tool(inputs)
});
export { directory_ads_dialog_submit_tool as "directory.ads.dialog_submit_tool" }